import { DefaultTheme } from 'styled-components';

export const theme: DefaultTheme = {
  colors: {
    primary: '#151F2B',
    secondary: '#1E2733',
    text: '#CFCFCF',
    grey: '#F5F5F5'
  },
  fonts: {
    primaryFamily: 'Montserrat'
  }
};
